// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import React from 'react'
import { object } from 'prop-types'
import { useElapsedTime } from 'hooks'

const FormatElapsedTime = ({ rowData }) => {
  const elapsedTime = useElapsedTime(rowData.startTime, rowData.endTime, rowData.analysisStatusId)

  return (
    <div
      title={elapsedTime}>
      {elapsedTime}
    </div>
  )
}

FormatElapsedTime.propTypes = {
  rowData: object.isRequired,
}

export default FormatElapsedTime
